import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/back-button.png'
import _imports_1 from '../assets/images/ball.svg'
import _imports_2 from '../assets/images/title.svg'
import _imports_3 from '../assets/images/mobile-gaming-console.svg'


const _withScopeId = n => (_pushScopeId("data-v-c6445d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "svg-btn",
  src: _imports_0
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-column p-m-auto",
  style: {"max-width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ball",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "box",
    src: _imports_2
  })
], -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-titlec p-mt-6" }, "Name your campaign", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-title p-mt-6" }, "Campaign end date:", -1))
const _hoisted_7 = {
  key: 0,
  class: "p-mt-4 p-d-flex p-ai-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-mr-3 p-ml-3" }, "or", -1))
const _hoisted_9 = {
  key: 1,
  class: "p-d-flex p-ai-center p-mt-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold p-mr-3" }, "* Until Budget is Complete", -1))
const _hoisted_11 = { class: "p-flex-column p-flex-wrap p-justify-center" }
const _hoisted_12 = { class: "p-mr-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-title p-mt-6" }, "Category", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-express-block p-d-flex p-flex-column" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus i-pi" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "type-title",
    style: {"color":"#686E6E"}
  }, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Select your preferred category ")
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "img-wrap p-flex-wrap"
}
const _hoisted_17 = { class: "p-mt-2 custom-express-block p-d-flex p-flex-column" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-type",
  src: _imports_3
}, null, -1))
const _hoisted_19 = { class: "type-title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "p-flex-column" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-title p-mt-6" }, "Payment method", -1))
const _hoisted_23 = {
  key: 0,
  class: "payment-type-camp"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "THIS IS FOR MOBILE GAMES/APPS ONLY.", -1))
const _hoisted_25 = {
  key: 1,
  class: "payment-type-camp"
}
const _hoisted_26 = {
  key: 2,
  class: "payment-type-camp"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-title" }, "Market", -1))
const _hoisted_29 = { class: "img-wrap p-flex-wrap" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"custom-express-block p-flex-column\" data-v-c6445d4e><div class=\"p-d-flex\" data-v-c6445d4e><div data-v-c6445d4e><span class=\"type-title\" style=\"color:#686E6E;\" data-v-c6445d4e><br data-v-c6445d4e>Select your preferred category</span><p style=\"padding-bottom:10px;\" data-v-c6445d4e>Make a selection on the type and coverage of the market</p></div><div data-v-c6445d4e><i class=\"pi pi-plus plus-img\" data-v-c6445d4e></i></div></div></div>", 1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-title" }, "Market", -1))
const _hoisted_34 = { class: "img-wrap p-flex-wrap" }
const _hoisted_35 = { class: "custom-express-block p-flex-column" }
const _hoisted_36 = { class: "p-d-flex" }
const _hoisted_37 = { class: "type-title" }
const _hoisted_38 = { class: "region-name" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down chevron-image" })
], -1))
const _hoisted_40 = { class: "markets-modal" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Search", -1))
const _hoisted_42 = { class: "p-input-icon-left w-100" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_44 = { class: "p-d-flex p-flex-wrap markets-modal" }
const _hoisted_45 = { class: "img-wrap p-flex-wrap" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "custom-express-block p-d-flex p-flex-column" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "type-title p-mt-5" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "p-d-flex p-justify-center p-mb-4 p-mt-4" }
const _hoisted_52 = {
  key: 1,
  class: "w-100 next-steeps"
}
const _hoisted_53 = { class: "p-d-flex p-justify-between block-steps p-pb-5" }
const _hoisted_54 = { class: "p-d-flex" }
const _hoisted_55 = { class: "p-text-bold p-d-flex p-ai-center" }
const _hoisted_56 = {
  key: 0,
  class: "p-grid p-col-12 p-justify-between main-body",
  style: {"padding-right":"5%","padding-left":"5%"}
}
const _hoisted_57 = { class: "p-col-12 p-lg-7" }
const _hoisted_58 = { class: "p-col-12 p-lg-4 p-mt-6" }
const _hoisted_59 = {
  key: 1,
  class: "p-grid p-col-12 p-justify-between main-body"
}
const _hoisted_60 = { class: "p-col-12 p-lg-7" }
const _hoisted_61 = { class: "p-col-12 p-lg-4 p-mt-6" }
const _hoisted_62 = {
  key: 2,
  class: "p-grid p-col-12 p-justify-between main-body"
}
const _hoisted_63 = { class: "p-col-12 p-lg-7" }
const _hoisted_64 = { class: "p-col-12 p-lg-4 p-mt-6" }
const _hoisted_65 = {
  key: 4,
  class: "p-grid p-col-12 p-justify-between main-body"
}
const _hoisted_66 = { class: "p-lg-4 p-mt-6" }
const _hoisted_67 = { class: "p-lg-8 p-mt-5" }
const _hoisted_68 = { class: "p-d-flex p-ai-center p-justify-between p-pr-6 p-flex-wrap buttons-nav" }
const _hoisted_69 = { class: "p-d-flex p-ai-baseline p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_market_modal = _resolveComponent("market-modal")!
  const _component_SecretTip = _resolveComponent("SecretTip")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_create_campaign_product_steep = _resolveComponent("create-campaign-product-steep")!
  const _component_accordeon_block_new = _resolveComponent("accordeon-block-new")!
  const _component_create_campaign_instructions_steep = _resolveComponent("create-campaign-instructions-steep")!
  const _component_create_campaign_budget_steep = _resolveComponent("create-campaign-budget-steep")!
  const _component_payment_information_modal = _resolveComponent("payment-information-modal")!
  const _component_short_campaign_page = _resolveComponent("short-campaign-page")!
  const _component_create_campaign_info_modal = _resolveComponent("create-campaign-info-modal")!
  const _component_campaign_success_modal = _resolveComponent("campaign-success-modal")!
  const _component_pay_and_finish_modal = _resolveComponent("pay-and-finish-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "new-camp-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1) ))
    }, [
      _hoisted_1,
      _createTextVNode("New Campaign ")
    ]),
    (_ctx.createCampaignStep === 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("section", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              type: "text",
              placeholder: "My Campaign title",
              modelValue: _ctx.progressCampaign.campaignName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.progressCampaign.campaignName) = $event)),
              "aria-describedby": "title-help",
              style: _normalizeStyle([[_ctx.progressCampaign.campaignName.length < 3 ? 'border: 1px solid red' : ''], {"width":"50%","min-width":"501px","height":"34px"}]),
              class: "tittle-input p-mt-6"
            }, null, 8, ["modelValue", "style"]),
            _hoisted_6,
            (_ctx.change)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_Calendar, {
                    id: "minmax",
                    modelValue: _ctx.endDateCampaign,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDateCampaign) = $event)),
                    minDate: _ctx.enD,
                    manualInput: false
                  }, null, 8, ["modelValue", "minDate"]),
                  _hoisted_8,
                  _createVNode(_component_Button, {
                    label: "set infinite",
                    icon: "pi pi-check",
                    class: "p-button-sm",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.change = false; _ctx.endDateCampaign = undefined})
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.change)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Button, {
                    label: "change",
                    icon: "pi pi-check",
                    class: "p-button-sm",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.change = true))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (!_ctx.selectedMarket)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["border-block-type-rework p-d-flex p-p-3", [_ctx.selected === 1 ? 'red-board' : '']]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.displayModalMarket = true;})
                    }, _hoisted_15, 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: "border-block-type-rework p-flex-column",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.displayModalMarket = true;})
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(_ctx.selectedMarket?.title), 1)
                          ])
                        ])
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedPaymentMethodX,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedPaymentMethodX) = $event)),
                  options: _ctx.paymentMethodsOptions,
                  class: "dropdown-type",
                  optionLabel: "title",
                  optionValue: "value",
                  placeholder: "Select a payment method"
                }, null, 8, ["modelValue", "options"]),
                (_ctx.selectedPaymentMethodX === 'CPI')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                      _createTextVNode(" A CPI (Cost Per Install) deal focuses on the number of installs a game or app gets through a specific tracking link. "),
                      _hoisted_24,
                      _createTextVNode(" When you opt for this pricing model, you essentially pay for the number of installs your game or app earns. This is good for you as you pay strictly based on the installs you want. However, CPI can be less attractive to many creators as they are often paid less than the actual number of downloads they influenced. ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedPaymentMethodX === 'CPM')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, " CPM (cost-per-mille) values the number of views sponsored videos get, with a cost per 1000 views. These views are tracked and paid out for the first 30 days that the video is live - all future views will not cost you but will still bring exposure to your ad. CPM enables you to focus on awareness and engagement. This payment method is very attractive to creators as they can better gauge the amount that they are likely to earn. Do consider that views do not equal conversions; also that one larger creators can use up a lot of budget, so make sure to set that max payout cap. "))
                  : _createCommentVNode("", true),
                (_ctx.selectedPaymentMethodX === 'CPC')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, " CPC (Cost per Click) advertising is a model in which advertisers are charged only when the actual click on the ad has been made. CPC represents the amount you are willing to pay for a single click. With CPC you only pay when the user is interested enough to know more about the product. You may see a high click through rate but that does not guarantee conversions. You need to make sure the landing page is attractive enough to generate conversions after clicks. "))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.marketModalInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "border-block-type-rework p-d-flex",
                        style: {"background-color":"#E0E0E0"},
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.displayMarketModal = true;})
                      }, _hoisted_31)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marketModalInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: "border-block-type-rework p-d-flex",
                        style: {"background-color":"#F8F9FA"},
                        onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.displayMarketModal = true;})
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.progressCampaign?.desiredRegions?.value), 1),
                              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.progressCampaign?.desiredRegions?.name), 1)
                            ]),
                            _hoisted_39
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_market_modal, {
                "display-market-modal": _ctx.displayMarketModal,
                "onUpdate:displayMarketModal": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.displayMarketModal) = $event)),
                onMarketModal: _ctx.marketModal
              }, null, 8, ["display-market-modal", "onMarketModal"])
            ]),
            _createVNode(_component_SecretTip, {
              text: 'Make sure this title is accurate to your product and snappy enough to entice creators!',
              class: "tip p-mt-6 p-mb-6"
            }),
            _createElementVNode("button", {
              class: "continue-button",
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.progressCampaign.campaignName.length >
       1  && _ctx.progressCampaign.targetMarkets?.type && _ctx.selectedPaymentMethodX ?
        _ctx.createCampaignStep = 3 : '')),
              style: {"width":"198px"}
            }, "Continue ")
          ]),
          _createVNode(_component_Dialog, {
            header: "Categories",
            visible: _ctx.displayModalMarket,
            "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.displayModalMarket) = $event)),
            style: {width: '75vw'},
            modal: true
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_Button, {
                  label: "Select market",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectMarket(_ctx.selectedMarket))),
                  class: "continue-button"
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("span", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.searchValueMarket,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchValueMarket) = $event)),
                    placeholder: "Search for Category or Country",
                    class: "tittle-input w-100",
                    onInput: _ctx.filterMarkets
                  }, null, 8, ["modelValue", "onInput"])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetMarkers, (type, indx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "main-block-type p-d-flex p-flex-wrap",
                    key: indx + 'm'
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["border-block-type p-d-flex", [_ctx.selected === indx + 1 ? 'red-board' : '']]),
                        onClick: ($event: any) => {_ctx.selected = indx + 1; _ctx.selectedMarket = type;}
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("img", {
                            class: "img-type",
                            src: _ctx.parseTypeIcons[type?.type]
                          }, null, 8, _hoisted_48),
                          _createElementVNode("span", _hoisted_49, [
                            _hoisted_50,
                            _createTextVNode(_toDisplayString(type?.title), 1)
                          ])
                        ])
                      ], 10, _hoisted_46)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.createCampaignStep > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationStep, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: item }, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-mr-3 count-step", [_ctx.paginationSteeps < index ? 'nexts-steeps' : 'previous-steep', _ctx.paginationSteeps === index ? 'current-steep' : '']])
                  }, " 0" + _toDisplayString(index + 1), 3),
                  _createElementVNode("span", _hoisted_55, _toDisplayString(item), 1)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.paginationSteeps === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_create_campaign_product_steep, {
                    campaign: _ctx.campaign,
                    onCountingProgress: _ctx.countingProgressProduct
                  }, null, 8, ["campaign", "onCountingProgress"])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_accordeon_block_new, {
                    "is-product-steep": _ctx.paginationSteeps === 0,
                    total: _ctx.totalProgress,
                    "count-progress": _ctx.CountProgress,
                    name: _ctx.progressCampaign.campaignName,
                    "campaign-photo": _ctx.progressCampaign?.photo,
                    instructions: !!(_ctx.TotalProgressCountObjects.talkingPoints && _ctx.TotalProgressCountObjects.callToAction
                            && _ctx.TotalProgressCountObjects.attachments),
                    onChangePhotos: _ctx.changePhotos,
                    details: !!(_ctx.TotalProgressCountObjects.productName && _ctx.TotalProgressCountObjects.talkingLink),
                    budget: !!(_ctx.TotalProgressCountObjects.budget && _ctx.TotalProgressCountObjects.paymentInformationDone)
                  }, null, 8, ["is-product-steep", "total", "count-progress", "name", "campaign-photo", "instructions", "onChangePhotos", "details", "budget"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.paginationSteeps === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_create_campaign_instructions_steep, {
                    onChangeInstruction: _ctx.changeInstruction,
                    campaign: _ctx.campaign,
                    attachments: _ctx.progressCampaign.attachments
                  }, null, 8, ["onChangeInstruction", "campaign", "attachments"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_accordeon_block_new, {
                    total: _ctx.totalProgress,
                    "count-progress": _ctx.CountProgress,
                    name: _ctx.progressCampaign.campaignName,
                    "campaign-photo": _ctx.progressCampaign?.photo,
                    instructions: !!(_ctx.TotalProgressCountObjects.talkingPoints && _ctx.TotalProgressCountObjects.callToAction
                            && _ctx.TotalProgressCountObjects.attachments),
                    onChangePhotos: _ctx.changePhotos,
                    details: !!(_ctx.TotalProgressCountObjects.productName && _ctx.TotalProgressCountObjects.talkingLink),
                    budget: !!(_ctx.TotalProgressCountObjects.budget && _ctx.TotalProgressCountObjects.paymentInformationDone)
                  }, null, 8, ["total", "count-progress", "name", "campaign-photo", "instructions", "onChangePhotos", "details", "budget"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.paginationSteeps === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_create_campaign_budget_steep, {
                    campaign: _ctx.campaign,
                    onBudgetSteep: _ctx.budgetSteep,
                    "payment-method": _ctx.selectedPaymentMethodX
                  }, null, 8, ["campaign", "onBudgetSteep", "payment-method"])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_accordeon_block_new, {
                    total: _ctx.totalProgress,
                    "count-progress": _ctx.CountProgress,
                    name: _ctx.progressCampaign.campaignName,
                    "campaign-photo": _ctx.progressCampaign?.photo,
                    instructions: !!(_ctx.TotalProgressCountObjects.talkingPoints && _ctx.TotalProgressCountObjects.callToAction
                            && _ctx.TotalProgressCountObjects.attachments),
                    onChangePhotos: _ctx.changePhotos,
                    details: !!(_ctx.TotalProgressCountObjects.productName && _ctx.TotalProgressCountObjects.talkingLink),
                    budget: !!(_ctx.TotalProgressCountObjects.budget && _ctx.TotalProgressCountObjects.paymentInformationDone)
                  }, null, 8, ["total", "count-progress", "name", "campaign-photo", "instructions", "onChangePhotos", "details", "budget"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.paginationSteeps === 3)
            ? (_openBlock(), _createBlock(_component_payment_information_modal, {
                key: 3,
                "show-modal": _ctx.showVerifyPaymentModal,
                "is-creator": false,
                onPaymentInfoChange: _ctx.paymentInfoChange
              }, null, 8, ["show-modal", "onPaymentInfoChange"]))
            : _createCommentVNode("", true),
          (_ctx.paginationSteeps === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_accordeon_block_new, {
                    total: _ctx.totalProgress,
                    "count-progress": _ctx.CountProgress,
                    name: _ctx.progressCampaign.campaignName,
                    "campaign-photo": _ctx.progressCampaign?.photo,
                    instructions: !!(_ctx.TotalProgressCountObjects.talkingPoints && _ctx.TotalProgressCountObjects.callToAction
                            && _ctx.TotalProgressCountObjects.attachments),
                    onChangePhotos: _ctx.changePhotos,
                    details: !!(_ctx.TotalProgressCountObjects.productName && _ctx.TotalProgressCountObjects.talkingLink),
                    budget: !!(_ctx.TotalProgressCountObjects.budget && _ctx.TotalProgressCountObjects.paymentInformationDone)
                  }, null, 8, ["total", "count-progress", "name", "campaign-photo", "instructions", "onChangePhotos", "details", "budget"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_short_campaign_page, {
                    campaignInfo: _ctx.progressCampaign,
                    "short-preview": true,
                    hideInfo: { isCampaignCPM: _ctx.progressCampaign && _ctx.progressCampaign.paymentMethod === 'CPM' }
                  }, null, 8, ["campaignInfo", "hideInfo"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("span", {
              class: "gray-btn",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.paginationSteeps === 0 ? _ctx.createCampaignStep -= 1 : _ctx.paginationSteeps -= 1))
            }, "PREVIOUS"),
            _createElementVNode("div", _hoisted_69, [
              (!_ctx.campaign)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "gray-btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createDraft(true)))
                  }, "SAVE DRAFT"))
                : _createCommentVNode("", true),
              (_ctx.paginationSteeps === 2)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Continue",
                    disabled: !_ctx.isMinimalBudgetRef || _ctx.isMinimalPayoutCap,
                    onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.paginationSteeps += 1;}),
                    class: "continue-button"
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.paginationSteeps === 3 && !_ctx.campaign)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    label: "Launch Campaign",
                    disabled: _ctx.loadingCreate,
                    loading: _ctx.loadingCreate,
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showInfoModal = true)),
                    class: "continue-button"
                  }, null, 8, ["disabled", "loading"]))
                : _createCommentVNode("", true),
              (_ctx.showInfoModal)
                ? (_openBlock(), _createBlock(_component_create_campaign_info_modal, {
                    key: 3,
                    onOkay: _ctx.launchCampaign
                  }, null, 8, ["onOkay"]))
                : _createCommentVNode("", true),
              (_ctx.paginationSteeps === 1)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 4,
                    label: "Continue",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.paginationSteeps += 1;}),
                    class: "continue-button"
                  }))
                : _createCommentVNode("", true),
              (_ctx.paginationSteeps === 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 5,
                    disabled: !_ctx.progressCampaign?.photo || _ctx.progressCampaign?.photo === '/images/defaultLogoCampaign.png',
                    label: "Continue",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.paginationSteeps += 1;}),
                    class: "continue-button"
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.paginationSteeps === 3 && _ctx.campaign)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 6,
                    label: "Save Campaign",
                    onClick: _ctx.saveCampaign,
                    class: "continue-button"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_campaign_success_modal, {
                "campaign-name": _ctx.progressCampaign.campaignName,
                "is-showing": _ctx.showSuccessModal,
                "onUpdate:isShowing": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showSuccessModal) = $event)),
                onCampaignLaunch: _ctx.goToNewCampaign
              }, null, 8, ["campaign-name", "is-showing", "onCampaignLaunch"]),
              _createVNode(_component_pay_and_finish_modal, {
                "first-pay-campaign": true,
                "new-data-budget": { budget: _ctx.progressCampaign.budget, cpi: _ctx.progressCampaign.cpi },
                "view-modal": _ctx.showPaymentModal,
                "campaign-id": _ctx.campaign ? _ctx.campaign?.id : _ctx.createdCamp?.id || _ctx.campaignID,
                onCampaignPaySuccess: _ctx.campaignPaySuccess
              }, null, 8, ["new-data-budget", "view-modal", "campaign-id", "onCampaignPaySuccess"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}